import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '@/pages/authentication/ui/LoginPage'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})
